const tours = {
  tour: "Lawatan", // translated 
  tours: "Lawatan", // translated 
  addOn: "Tambah Pada", // translated 
  addOns: "Tambahan", // translated 
  availableEscapes: "Pelarian yang Tersedia", // translated 
  availableExperiences: "Pengalaman yang Tersedia", // translated 
  getRequest: "Dapatkan Permintaan", // translated 
  sendRequest: "Hantar Permintaan", // translated 
};






export default tours;
